import axios from 'axios';
import { API_URL } from '../config/api';

/**
 * User Service
 * 
 * WHAT THIS FILE DOES:
 * Makes API calls to get user information from the backend
 * 
 * Think of this like a phone:
 * - Component says: "I need a list of users"
 * - This service calls the backend: "Hey backend, give me users!"
 * - Backend responds with data
 * - This service gives data back to the component
 */

const API_BASE = API_URL;

// Create axios instance with auth
const api = axios.create({
  baseURL: API_BASE
});

// Add auth token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const userService = {
  
  /**
   * Get all active users
   * Usage: const users = await userService.getAll();
   */
  getAll: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  /**
   * Get internal users only (your team members)
   * Usage: const teamMembers = await userService.getInternalUsers();
   */
  getInternalUsers: async () => {
    const response = await api.get('/users/internal');
    return response.data;
  },

  /**
   * Get a specific user by their ID
   * Usage: const user = await userService.getById(5);
   */
  getById: async (userId) => {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  },

  /**
   * Get client users for a specific firm
   * Usage: const clients = await userService.getClientUsers(10);
   */
  getClientUsers: async (firmId) => {
    const response = await api.get(`/users/firm/${firmId}/clients`);
    return response.data;
  }
};

export default userService;
